var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ml-5 mt-5 d-flex"},[_c('br'),_c('div',{staticClass:"w-100px h-100px border-teal rotate-50"},[_vm._v("rotate")])])}]

export { render, staticRenderFns }